import React from 'react';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const AiReportList = ({ data = [], onTranscriptClick, onHangupClick }) => {
  return (
    <div className="report-list-table-wrapper ai-report-list-table-wrapper">
      <table className="report-list-table">
        <thead>
          <tr>
            <th>Destination Number</th>
            <th>Caller ID</th>
            <th className="text-center">Status</th>
            <th className="text-center">Duration</th>
            <th>Date &amp; Time</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0
            ? data.map((row, index) => (
                <tr key={row.session_id || index} style={{ fontWeight: 'bold' }}>
                  <td>{row.destination_number || '-'}</td>
                  <td>{row.caller_id_number || '-'}</td>
                  <td className="text-center">{row.status || '-'}</td>
                  <td className="text-center">{row.duration || '-'}</td>
                  <td>{row.date_and_time || '-'}</td>
                  <td className="text-center">
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <Icon.FileText
                        size={18}
                        className="cursor-pointer text-primary"
                        title="View transcript"
                        onClick={() => onTranscriptClick(row)}
                      />
                      <Icon.PhoneOff
                        size={18}
                        className="cursor-pointer text-danger"
                        title="Hang up call"
                        onClick={() => onHangupClick(row)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};

AiReportList.propTypes = {
  data: PropTypes.array,
  onTranscriptClick: PropTypes.func.isRequired,
  onHangupClick: PropTypes.func.isRequired
};

export default AiReportList;
